import { render } from "./InstructionsView.vue?vue&type=template&id=df5eeb50&scoped=true"
import script from "./InstructionsView.vue?vue&type=script&lang=js"
export * from "./InstructionsView.vue?vue&type=script&lang=js"

import "./InstructionsView.vue?vue&type=style&index=0&id=df5eeb50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df5eeb50"]])

export default __exports__